module.exports = __webpack_public_path__ + "media/images/top/top-main-image-97fee9ed26ee1133e108b0b7ef2ee246.jpg";